// extracted by mini-css-extract-plugin
module.exports = {"container":"_1a2H8s09Y-x5omKaDktDZg","iconWrapper":"_1jrDmURtCO_K4T6A94ou8i","textWrapper":"_3QjeJL6o5bLcM-XdaID-QU"};